export const homeImage =
	"https://smcore.blob.core.windows.net/logos/fupre_grid_image.png";
export const birthdayImage =
	"https://smcore.blob.core.windows.net/logos/birthday.png";
